import React from 'react';
import ModifierGroupsField from './components/ModifierGroupsField';
import ModifierGroupsAsAdditionalField from './components/ModifierGroupsAsAdditionalField';
import AdditionalIngredientsField from './components/AdditionalIngredientsField';
import SuggestedDishesField from './components/SuggestedDishesField';
import DishModificationsField from './components/DishModificationsField';
import style from './ModifiersSection.module.scss';

const ModifiersSection: React.FC = () => {
	return (
		<div className={style.container}>
			<ModifierGroupsField />
			<ModifierGroupsAsAdditionalField />
			<AdditionalIngredientsField />
			<SuggestedDishesField />
			<DishModificationsField />
		</div>
	);
};

export default ModifiersSection;
